export default __webpack_public_path__ + "6469a475b4775b844ce0007050667d3e.png";